export const getResultItemId = index => `search-result-${index}`;
